/* A2Z EV Pro theme */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Toast ---------- */
  function toast(msg) {
    var t = $('#a2z-toast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._t); t._t = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }

  /* ---------- Mega menu ---------- */
  $$('[data-mega-toggle]').forEach(function (btn) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    function close() { btn.setAttribute('aria-expanded', 'false'); panel.classList.remove('is-open'); }
    function open() {
      $$('[data-mega-toggle][aria-expanded="true"]').forEach(function (b) {
        if (b !== btn) { b.setAttribute('aria-expanded', 'false'); var p = document.getElementById(b.getAttribute('aria-controls')); if (p) p.classList.remove('is-open'); }
      });
      btn.setAttribute('aria-expanded', 'true'); panel.classList.add('is-open');
    }
    btn.addEventListener('click', function (e) { if (window.matchMedia('(hover:hover)').matches) return; e.preventDefault(); btn.getAttribute('aria-expanded') === 'true' ? close() : open(); });
    var li = btn.closest('li');
    if (li && window.matchMedia('(hover:hover)').matches) {
      var timer;
      li.addEventListener('mouseenter', function () { clearTimeout(timer); open(); });
      li.addEventListener('mouseleave', function () { timer = setTimeout(close, 160); });
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    document.addEventListener('click', function (e) { if (!li.contains(e.target)) close(); });
  });

  /* ---------- Drawers + modals ---------- */
  var lastFocus = null;
  function openLayer(el) {
    if (!el) return; lastFocus = document.activeElement;
    el.classList.add('is-open'); document.body.style.overflow = 'hidden';
    var f = el.querySelector('input,select,textarea,button,a[href]'); if (f) setTimeout(function () { f.focus(); }, 30);
  }
  function closeLayer(el) {
    if (!el) return; el.classList.remove('is-open'); document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); var t = document.getElementById(o.getAttribute('data-open')); if (t && t.id === 'quote-modal') prefillQuote(o); openLayer(t); return; }
    var c = e.target.closest('[data-close]');
    if (c) { e.preventDefault(); closeLayer(c.closest('.drawer,.modal')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('.drawer.is-open,.modal.is-open').forEach(closeLayer);
  });

  /* ---------- Quote list (stored in this browser) ---------- */
  var KEY = 'a2z-quote-list';
  function readList() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function writeList(l) { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} renderCount(); }
  function renderCount() {
    var n = readList().reduce(function (a, i) { return a + (parseInt(i.qty, 10) || 1); }, 0);
    $$('[data-quote-count]').forEach(function (b) { b.textContent = n; b.setAttribute('data-count', n); });
  }
  function addToQuote(item) {
    var l = readList(); var found = l.filter(function (i) { return i.handle === item.handle && i.variant === item.variant; })[0];
    if (found) found.qty = (parseInt(found.qty, 10) || 1) + (parseInt(item.qty, 10) || 1); else l.push(item);
    writeList(l); toast(item.title + ' added to your quote list');
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add-quote]'); if (!b) return;
    e.preventDefault();
    var form = b.closest('form'); var qtyEl = form ? form.querySelector('[name="quantity"]') : null;
    var vEl = form ? form.querySelector('[name="id"]') : null;
    var vLabel = form ? form.querySelector('[data-variant-title]') : null;
    addToQuote({ handle: b.dataset.handle, title: b.dataset.title, image: b.dataset.image || '', url: b.dataset.url || '',
      variant: vEl ? vEl.value : '', variantTitle: vLabel ? vLabel.textContent.trim() : '', qty: qtyEl ? qtyEl.value : (b.dataset.qty || 1) });
  });
  function listToText(l) {
    return l.map(function (i) { return '• ' + i.title + (i.variantTitle && i.variantTitle !== 'Default Title' ? ' (' + i.variantTitle + ')' : '') + ' — qty ' + i.qty + (i.url ? ' — ' + location.origin + i.url : ''); }).join('\n');
  }
  function renderQuotePage() {
    var root = $('[data-quote-page]'); if (!root) return;
    var ul = $('[data-quote-items]', root), empty = $('[data-quote-empty]', root), field = $('[data-quote-field]', root), formWrap = $('[data-quote-form]', root);
    var l = readList(); ul.innerHTML = '';
    if (!l.length) { empty.hidden = false; formWrap.hidden = false; field.value = ''; return; }
    empty.hidden = true; formWrap.hidden = false;
    l.forEach(function (i, idx) {
      var li = document.createElement('li');
      li.innerHTML = '<img alt="" loading="lazy"><div><a></a><small class="tnum"></small></div><input type="number" min="1" aria-label="Quantity"><button type="button" class="icon-btn" aria-label="Remove">✕</button>';
      var img = li.querySelector('img'); if (i.image) img.src = i.image; else img.style.visibility = 'hidden';
      var a = li.querySelector('a'); a.textContent = i.title; a.href = i.url || '#';
      li.querySelector('small').textContent = (i.variantTitle && i.variantTitle !== 'Default Title') ? ' ' + i.variantTitle : '';
      var q = li.querySelector('input'); q.value = i.qty;
      q.addEventListener('change', function () { var x = readList(); x[idx].qty = Math.max(1, parseInt(q.value, 10) || 1); writeList(x); field.value = listToText(x); });
      li.querySelector('button').addEventListener('click', function () { var x = readList(); x.splice(idx, 1); writeList(x); renderQuotePage(); });
      ul.appendChild(li);
    });
    field.value = listToText(l);
  }
  var qp = $('[data-quote-page]');
  if (qp) {
    var qf = qp.querySelector('form');
    if (qf && /contact_posted=true/.test(location.search)) { writeList([]); }
    renderQuotePage();
  }
  function prefillQuote(trigger) {
    var m = $('#quote-modal'); if (!m) return;
    var p = m.querySelector('[name="contact[Product]"]'); var t = trigger.getAttribute('data-product');
    if (p) p.value = t || '';
    var area = trigger.getAttribute('data-area');
    if (area) $$('[name="contact[Product area]"]', m).forEach(function (s) { if (s.tagName === 'SELECT') s.value = area; });
  }

  /* ---------- Adapter finder ---------- */
  $$('[data-finder]').forEach(function (root) {
    var data = []; try { data = JSON.parse(root.querySelector('[data-finder-map]').textContent); } catch (e) {}
    var ch = root.querySelector('[name="charger"]'), ve = root.querySelector('[name="vehicle"]');
    var out = root.querySelector('[data-finder-result]'), mode = 'DC';
    var base = root.getAttribute('data-base') || '/collections/all';
    $$('[data-mode]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        mode = b.getAttribute('data-mode');
        $$('[data-mode]', root).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        run();
      });
    });
    function slug(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
    function run() {
      var c = ch.value, v = ve.value; out.innerHTML = '';
      if (!c || !v) { out.innerHTML = '<p class="finder__empty">Choose the connector on the charger and the port on the vehicle.</p>'; return; }
      if (c === v && mode !== 'V2L') { out.innerHTML = '<p class="finder__empty">Same connector on both sides — no adapter needed. Need more reach? Look at extension cords.</p>'; return; }
      var hit = data.filter(function (d) { return d.charger === c && d.vehicle === v && (d.mode === mode || d.mode === 'DC+AC' || mode === 'any'); })[0];
      var tags = [slug('Charger ' + c), slug('Vehicle ' + v)];
      var all = base.replace(/\/$/, '') + '/' + tags.join('+');
      var html = '';
      if (hit) {
        html += '<a class="finder__match" href="' + hit.url + '">' + (hit.image ? '<img src="' + hit.image + '" alt="" width="84" height="84" loading="lazy">' : '<span></span>') +
          '<span><strong>' + hit.title + '</strong><span class="finder__note">' + (hit.note || '') + '</span></span></a>';
      }
      html += '<p class="finder__note"><a class="link-y" href="' + all + '">See every ' + c + ' → ' + v + ' option</a></p>';
      out.innerHTML = html;
    }
    ch.addEventListener('change', run); ve.addEventListener('change', run);
    var sw = root.querySelector('[data-swap]');
    if (sw) sw.addEventListener('click', function () { var a = ch.value; ch.value = ve.value; ve.value = a; run(); });
    run();
  });

  /* ---------- Product gallery ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('.js-gallery-main'); if (!main) return;
    $$('[data-thumb]', g).forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.getAttribute('data-src'); main.srcset = t.getAttribute('data-srcset') || ''; main.alt = t.getAttribute('data-alt') || '';
        $$('[data-thumb]', g).forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
      });
    });
  });

  /* ---------- Tabs ---------- */
  $$('[role="tablist"]').forEach(function (list) {
    var tabs = $$('[role="tab"]', list);
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i); });
      tab.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); select((i + 1) % tabs.length, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); select((i - 1 + tabs.length) % tabs.length, true); }
      });
    });
    function select(i, focus) {
      tabs.forEach(function (t, j) {
        var on = i === j; t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls')); if (p) p.hidden = !on;
      });
      if (focus) tabs[i].focus();
    }
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]'); if (!b) return;
    var input = b.parentNode.querySelector('input'); var v = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, v + (b.getAttribute('data-qty') === '+' ? 1 : -1));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Variant picker ---------- */
  $$('[data-variant-picker]').forEach(function (vp) {
    var variants = []; try { variants = JSON.parse(vp.querySelector('[data-variants]').textContent); } catch (e) {}
    var form = vp.closest('form'); var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-price]'); var btn = form.querySelector('[data-add-cart]');
    var label = form.querySelector('[data-variant-title]');
    vp.addEventListener('change', function () {
      var sel = $$('fieldset', vp).map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
      var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0];
      if (!v) return;
      idInput.value = v.id; if (label) label.textContent = v.title;
      if (priceEl && v.price_html) priceEl.innerHTML = v.price_html;
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? btn.getAttribute('data-label') : btn.getAttribute('data-soldout'); }
      if (v.image) { var main = document.querySelector('.js-gallery-main'); if (main) { main.src = v.image; main.removeAttribute('srcset'); } }
      var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    });
  });

  /* ---------- Collection filters ---------- */
  $$('[data-filter-form]').forEach(function (f) {
    f.addEventListener('change', function () { f.submit(); });
  });
  $$('[data-sort]').forEach(function (s) {
    s.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', s.value); location.href = u.toString(); });
  });
  var ft = $('[data-filter-toggle]');
  if (ft) ft.addEventListener('click', function () { var f = $('.filters'); var on = f.classList.toggle('is-open'); ft.setAttribute('aria-expanded', on); });

  renderCount();
})();
